import React, { useEffect } from 'react'
import styles from "../vendorprofile/myprofile.module.css"
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu'
import VenEnquiryDeets from '../../Components/allVenEnquiresTab/VenEnquiryDeets'
import Myprofile from '../../../CustomerDash/Pages/myprofile/Myprofile'
import { useDispatch, useSelector } from 'react-redux'
import { getRecievedDetailsThunk } from '../../../../Website/redux/recievedEnquiriesSlice'
import { useParams } from 'react-router-dom'

const VenEnquiryDetails = () => {

    const dispatch = useDispatch()
    const { enquiryDetails, refresh, loading } = useSelector((state) => state.recievedEnquiries)
    console.log(enquiryDetails);

    const { id } = useParams()
    useEffect(() => {
        dispatch(getRecievedDetailsThunk(id))
    }, [refresh])

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 10 }}>
                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
            </div>
        )
    }

    return (
        <>
            <Myprofile>

                <VenEnquiryDeets enquiryDetails={enquiryDetails} />
            </Myprofile>
        </>
    )
}

export default VenEnquiryDetails